import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	uploadCsv: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.upload-csv.upload-csv',
		defaultMessage: 'Upload CSV file',
		description: 'Upload CSV button text',
	},
	fileNotUploadedError: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.upload-csv.file-not-uploaded-error',
		defaultMessage: 'Upload a CSV file to proceed.',
		description: 'CSV file not uploaded error',
	},
});
